import { useColorModeValue } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Image, Progress } from '@bonusly/design-system';

import { useOneOnOnesAccess } from '../hooks/use-one-on-ones-access';
import { useFeedbackProgress } from '../hooks/use-progress';
import { Person } from '../types';
import { StyledProgressLabel } from './progress-bar';

interface FeedbackProgressProps {
	people: Person[];
}

export const FeedbackProgress: FC<FeedbackProgressProps> = ({ people }) => {
	const { t } = useTranslation('tracker_widget');
	const { canAccessOneOnOnes } = useOneOnOnesAccess();
	const progressBg = useColorModeValue('white', 'blueAlpha.300');

	const { directReportsTotal, directReportsGivenFeedback, feedbackFace, feedbackSvgPos, feedbackVisualProgress } = useFeedbackProgress(people);

	if (!canAccessOneOnOnes) return null;

	return (
		<>
			<Flex justifyContent="space-between" mt={2} mb={1}>
				<StyledProgressLabel>{t('progress_bar.feedback_title')}</StyledProgressLabel>
				<StyledProgressLabel>
					{directReportsGivenFeedback}/{directReportsTotal}
				</StyledProgressLabel>
			</Flex>
			<Progress
				value={feedbackVisualProgress}
				height="1.5rem"
				borderRadius={100}
				backgroundColor={progressBg}
				styleConfig={{
					baseStyle: {
						filledTrack: {
							backgroundColor: 'purple.200',
						},
					},
				}}
			>
				<Image src={feedbackFace} style={feedbackSvgPos} />
			</Progress>
		</>
	);
};
